export const en = {
    admin: {
        user: 'Customer mode',
        userModeDescription:
            'When selected it shows the page the way the customer will see it',
    },
    app: {
        forvalter: 'Real estate dashboard',
        mittleieforhold: 'My lease',
        openInSuperOffice: 'SuperOffice',
        verified: 'Verified',
        d365: 'Dynamics 365',
        eiendomGpt: 'EiendomGPT',
    },
    auth: {
        authorizing: 'Authorizing...',
        loggingOut: 'Logging out...',
        login: 'Login',
        logout: 'Logout',
        privacyDescription:
            'By using this site, you agree that we collect information that is used to improve ' +
            'he user experience for the users of this page. Read about the processing of personal data in My tenancy in our ',
        privacyLinkTitle: 'privacy policy.',
        sessionTimeout: 'Your session has expired',
        sessionTimeoutLoginAgain: 'Please login again.',
    },
    breadcrumbs: {
        building: 'Property',
        byggUtleie: 'Rental',
        contract: 'Contracts',
        dashboard: 'My Lease',
        invoice: 'Invoices',
        listUsers: 'Users',
        message: 'Message board',
        registerUser: 'Register user',
        searchUsers: 'Search for users',
        selectClient: 'Select client',
        ticket: 'Tickets',
    },
    buildingClientChooser: {
        groupByBuilding: 'Group by property',
        groupByClient: 'Group by client',
        recipients: {
            all: 'All recipients',
            search: 'Search recipients',
            select: 'Recipients',
            selected: 'Selected recipients',
        },
    },
    bygg: {
        activeClients: 'Active customers',
        adresse: 'Address',
        andelFossilEl: 'Percentage of fossil/el',
        arealType: 'Type',
        backToOverview: 'Back to property overview',
        backToOverviewForClient: 'Back to properties for {{customerName}}',
        beskrivelse: 'About the property',
        bygg: 'Property',
        byggeAar: 'Year of construction',
        byggInfo: {
            numberOfBuildings: '{{count}} properties',
            numberOfBuildings_1: '{{count}} property',
            numberOfContracts: '{{count}} agreements',
            numberOfContracts_1: '{{count}} agreement',
        },
        byggListTitle: 'My properties',
        byggListTitleAdmin:
            'Properties for {{customerName}} ({{customerNumber}})',
        byggListTitleAdminAllBuildings: 'All properties',
        byggNummer: 'Building number',
        byggSearch: 'Search properties',
        contractDetails: 'Economy',
        customers: 'Customers',
        documents: 'Documents and drawings',
        driftsAnsvarlig: 'Maintenance manager',
        driftsTekniker: 'Maintenance technician',
        eiendomsAnsvarlig: 'Property manager',
        eiendomsNummer: 'Property number',
        energiForbruk: 'Estimated energy usage',
        energiKarakter: 'Energy mark',
        errorList: {
            description: 'Something went wrong when fetching properties.',
            title: 'Something went wrong when fetching properties.',
        },
        errorNoClients: {
            title: 'No clients found for this building.',
        },
        errorNotFound: {
            description: 'No properties found.',
            title: 'No properties found.',
        },
        errorSingle: {
            description: 'Something went wrong when fetching property.',
            title: 'Something went wrong when fetching property.',
        },
        etasjer: 'Floors',
        forbruk: 'Environmental profile',
        futureClients: 'Future customers',
        gabNummer: 'GAB-number',
        inactiveClients: 'Inactive customers',
        kompleksNummer: 'Complex number',
        name: 'Name',
        overview: 'Overview',
        searchDocument: {
            placeholder: 'Start typing here',
            title: 'Search documents',
        },
        showAll: 'Show all properties',
        tickets: 'Tickets',
        totAreal: 'Total area',
        shortcut: 'Shortcut',
    },
    byggCalendar: {
        name: 'Calendar',
        error: {
            title: 'Something went wrong',
            description:
                "We're having trouble displaying the calendar for this property right now. Please try again shortly.",
        },
    },
    byggDokument: {
        errorDownload: {
            description: 'Something went wrong while fetching documents.',
            title: 'Something went wrong while fetching documents.',
        },
        errorNotFound: {
            description: 'No documents found.',
            title: 'No documents found.',
        },
        tableTitle: {
            generalInfo: 'General Information',
            contractAttachment: 'Contract annex',
            fire: 'Fire',
            escape: 'Escape',
        },
        etasje: 'Floor',
        maalestokk: 'Scale',
        navn: 'Name',
        nummer: 'Number',
        revdato: 'Revision',
    },
    byggUtleie: {
        areaAvailable: 'Available area',
        areaLeased: 'Leased area',
        areaRatio: 'Area-wise Rental Ratio',
        areaToExpire: 'Expiring area',
        available: 'Available',
        econRatio: 'Economic Rental Ratio',
        expires: 'Expiring',
        expiring: 'Expiring contracts',
        leased: 'Leased',
        menu: 'Rental',
        title: 'Property rental',
        vacant: 'Vacant properties per {{from}}',
    },
    clientSelect: {
        chooseClient: 'Select client',
        clientName: 'Client name',
        clientNumber: 'Client number',
        clientLastActiveInML: 'Last active in My Lease',
        errorNoClients: {
            description: 'Contact us to fix this.',
            title: "You don't have any active agreement.",
        },
        errorNoClientsSelected: {
            description: "You have to select the client to see it's data.",
            title: 'No client selected',
        },
        notFound: 'No clients found.',
        searchClient: 'Search client',
        selectAktiveOnly: 'Check to only include clients with active contracts',
        selectedClient: 'Selected client: {{customerName}}',
        welcomeMessageSent: 'Welcome message sent',
    },
    contractManagement: {
        title: 'Contracts',
        leko: 'Contract Negotiation',
        avtaler: 'My Leases',
    },
    contractFrame: {
        externalFrame: {
            actionButton: 'Open contract negotiation',
            contractNotFoundTitle: "Can't find your terms",
            contractNotFoundDescription:
                "You can find all your buildings' current rental conditions under the respective building",
            contractNotFoundLink: 'Go to my buildings',
            manualContractDescription:
                'You can get a copy of your contracts in PDF form by contacting your KLP property manager',
            manualContractTitle:
                'Are you looking for an existing PDF contract document?',
            title: 'Contract negotiations must be opened in a new tab',
            description: 'To open the contract negotiation, we need a new tab',
        },
    },
    dxboFrame: {
        externalFrame: {
            actionButton: 'Open Decision Portal',
            description:
                'To open the decision portal, we need to use a new tab',
            title: 'Looking to customize your newly rented space?',
        },
    },
    leaseAgreement: {
        table: {
            property: 'Property',
            propertyNumber: 'Property No.',
            propertyName: 'Property',
            name: 'Name',
            quantity: 'Area',
            leaseFromDate: 'From',
            leaseToDate: 'To',
            contractNumber: 'Contract No.',
            notFound: 'No leases found.',
        },
        title: 'Mine Leases',
        activeAgreement: 'Active agreements',
        archivedAgreement: 'Inactive agreements',
        futureAgreement: 'Future agreements',
        errorDownload: {
            description: 'Something went wrong when fetching leases.',
            title: 'Something went wrong when fetching leases.',
        },
    },
    environment: {
        description:
            'This service may seem unstable for some periods. ' +
            'We are continuously developing and improving it and appreciate all your feedback and suggestions.',
        dev: 'DEV',
        environment: 'Environment: ',
        local: 'LOCAL',
        test: 'TEST',
    },
    faktura: {
        amount: 'Amount',
        betalingsgrad: 'Payment ratio',
        inkasso: 'Debt collection',
        purring: 'Reminder',
        delayed: 'Delayed',
        delayedPayments: 'Delayed payments',
        delayedPayments_0: 'Delayed payment',
        dueDate: 'Due date',
        errorDownload: {
            description: 'Something went wrong when fetching invoices.',
            title: 'Something went wrong when fetching invoices.',
        },
        errorNotFound: {
            description: 'No invoices found.',
            title: 'No invoices found.',
        },
        emptyTable: 'No invoices match your search.',
        faktura: 'Invoices',
        faktura_1: 'Invoice',
        fakturaNumber: 'Invoice number',
        incomingPayments: 'Incoming payments',
        incomingPayments_0: 'Incoming payment',
        invoiceNumberShort: 'No',
        invoicesFor: 'Invoices for {{kundeName}} ({{kundeNummer}})',
        invoiceSummary: `Sum: {{sum}}kr of which {{delayed}}kr is delayed`,
        issueDate: 'Issue date',
        lastpaymentdate: 'Last payment',
        left: 'Left',
        myInvoices: 'My invoices',
        notSettledInvoices: 'Unpaid invoices',
        notSettledInvoices_1: 'Unpaid invoice',
        paid: 'Paid',
        payments: 'Payments',
        refunds: 'Refunds',
        refunds_0: 'Refund',
        settledInvoice_0: 'Settled invoice',
        settledInvoices: 'Settled invoices',
        status: 'Status',
    },
    fakturaStatus: {
        AwaitingPayment: 'Awaiting Payment',
        AwaitingRefund: 'Awaiting Refund',
        Refunded: 'Refunded',
        Paid: 'Paid',
        PartiallyPayed: 'Partially Payed',
        Overdue: 'Overdue',
        Unknown: 'Unknown',
    },
    file: {
        deleting: 'Deleting files...',
        deleting_1: 'Deleting file...',
        downloading: 'Downloading...',
        fileNotFound: 'File not found',
        preview: 'Preview',
        previewDownload: 'Preview / Download',
        saving: 'Saving files...',
        saving_1: 'Saving file...',
        selectFiles: 'Select files',
        selectFiles_0: 'Select file',
        downloadFailed: 'Download failed',
        downloadSuccess: 'The file has been downloaded',
    },
    footer: {
        contactIntro: 'We will help you',
        email: {
            prefix: 'Email: ',
            text: 'Write to us',
            url: {
                no: 'mailto:kundeogmiljosenter@klpeiendom.no',
                en: 'mailto:kundeogmiljosenter@klpeiendom.no',
                sv: 'mailto:info@klpfastigheter.se',
                da: 'mailto:kbh@klp.no',
            },
        },
        openingHours: {
            no: 'Available 24/7',
            en: 'Available 24/7',
            sv: 'Available 24/7',
            da: 'Staffed during office hours',
        },
        phone: {
            prefix: 'Phone: ',
            no: {
                title: '23 08 08 14',
                url: 'tel:+4723080814',
            },
            en: {
                title: '23 08 08 14',
                url: 'tel:+4723080814',
            },
            sv: {
                title: '08-657 77 56',
                url: 'tel:+4686577756',
            },
            da: {
                title: '(+45) 70 26 26 61',
                url: 'tel:+4570262661',
            },
        },
        privacy: {
            description: 'Privacy policy',
            url: {
                no: 'https://www.klpeiendom.no/oslo/om-klp-eiendom/personvern',
                en: 'https://www.klpeiendom.no/oslo/om-klp-eiendom/personvern',
                sv: 'https://www.klpfastigheter.se/stockholm/om-oss/personuppgifter',
                da: 'https://www.klpejendomme.dk/kobenhavn/om-os/persondatapolitik',
            },
        },
        newSak: {
            text: 'Register a new case',
            link: 'https://mittleieforhold.klpeiendom.no/sak/add',
        },
    },
    frontPage: {
        accountSettings: 'Account Settings',
        buildings: 'Property',
        buildingsLink: 'My properties',
        contract: 'Contracts',
        contractManagement: {
            subtitle: 'Negotiating a new contract?',
            contractNegotiation: 'Contract Negotiation',
        },
        dxboProject: 'Decision Portal',
        expiringContracts: 'Expiring contracts',
        frontpage: 'Frontpage',
        invoice: {
            title: 'Invoices',
            invoiceLink: 'All invoices',
            sumOutstanding: 'Sum outstanding: ',
            outstandingInvoiceCount: 'Invoice: {{outstandingInvoiceCount}} pcs',
            outstanding: 'Outstanding',
        },
        messages: 'Message board',
        messagesLink: 'See all messages',
        mytasksLink: 'Task overview',
        errorReporting: 'Error report',
        newsFeed: {
            title: 'Latest from KLP Eiendom:',
            linkText: 'View everything from KLP Eiendom on LinkedIn',
        },
        twoFactorAlertText: 'Two-factor authentication available',
        boldTwoFactorAlertText: ' - Activate it in Account Settings!',
        welcome: {
            mittleieforhold: 'Welcome to My Lease',
        },
        miljo: {
            title: 'Environment',
        },
        sustainability: {
            title: 'Sustainability',
        },
        miljoprofil: {
            title: 'Building environmental profile',
        },
    },
    editor: {
        paragraph: 'Paragraph',
        heading1: 'Heading 1',
        heading2: 'Heading 2',
        heading3: 'Heading 3',
        heading4: 'Heading 4',
        heading5: 'Heading 5',
        heading6: 'Heading 6',
        horizontalRule: 'Horizontal rule',
        insertTable: 'Insert table',
        loadingEditor: 'Loading editor...',
        addColumnBefore: 'Add column before',
        addColumnAfter: 'Add column after',
        deleteColumn: 'Delete column',
        addRowBefore: 'Add row before',
        addRowAfter: 'Add row after',
        deleteRow: 'Delete row',
        deleteTable: 'Delete table',
    },
    general: {
        adminContent: 'This is only visible to admin users',
        backToTop: 'Back to top',
        by: 'by',
        cancel: 'Cancel',
        clear: 'Clear',
        clearList: 'Clear list',
        clearSelection: 'Clear selection',
        close: 'Close',
        confirm: 'Yes',
        days: 'days',
        days_0: 'day',
        decline: 'No',
        delete: 'Delete',
        details: 'Details',
        download: 'Download',
        draft: 'Draft',
        edit: 'Edit',
        emptyList: 'List is empty',
        successfulOperation: 'The action was successfully completed.',
        error: 'Error',
        errorMessage: 'An error has occurred. \n Please try again later.',
        expired: 'Expired',
        goBack: 'Go back',
        goBackToFrontpage: 'Go back to the frontpage',
        loading: 'Loading...',
        deleting: 'Deleting...',
        menu: 'Menu',
        month: 'Month',
        month_0: 'Jan',
        month_1: 'Feb',
        month_2: 'Mar',
        month_3: 'Apr',
        month_4: 'May',
        month_5: 'Jun',
        month_6: 'Jul',
        month_7: 'Aug',
        month_8: 'Sep',
        month_9: 'Oct',
        month_10: 'Nov',
        month_11: 'Des',
        noIe:
            'We are sorry, but this feature is not supported in Internet Explorer. ' +
            'We recommend to use Google Chrome or Mozilla Firefox browser.',
        of: 'of',
        open: 'Open',
        outdatedBrowser: {
            description:
                'Dear user! Your browser is outdated and some features may not work as intended. We recommend to use Google Chrome or Mozilla Firefox browser.',
            title: 'Warning - outdated browser',
        },
        pageNotFound: 'Page not found',
        preview: 'Preview',
        previewDownload: 'Preview / Download',
        publish: 'Publish',
        readMore: 'Read more',
        reload: 'Reload',
        reset: 'Reset',
        save: 'Save',
        saveAsDraft: 'Save as draft',
        saved: 'Saved',
        saving: 'Saving...',
        show: 'show',
        showAll: 'Show all',
        submit: 'Submit',
        sum: 'sum',
        updating: 'Updating...',
        wrote: 'Wrote',
    },
    kontrakt: {
        agreements: 'contracts',
        agreements_1: 'contract',
        agreementRows: 'rows',
        agreementRows_1: 'row',
        antall: 'Quantity',
        antenne: 'Antenna',
        'annet uten fellesar': 'Other without common area',
        arkiv: 'Archive',
        arligEiendomskatt: 'Annual property tax',
        arligFellesKostnad: 'Annual shared cost',
        arligLeie: 'Annual rent',
        bod: 'Shed',
        bolig: 'Residence',
        butikk: 'Store',
        'bygg felles': 'common building',
        coworking: 'Coworking',
        energiForbrukPrM2: 'Energy consumption per m²',
        errorContractNotFound: {
            description: "We couldn't find any contract for this property.",
            title: 'No contracts found.',
        },
        errorDownload: {
            description: 'Something went wrong downloading contracts.',
            title: 'Error downloading contracts.',
        },
        felles: 'Common',
        felleskostnaderPrM2: 'Shared costs per m²',
        festetomter: 'Leased plots',
        forretning: 'Business',
        'forretning uten fel': 'Business without common area',
        fra: 'From',
        garasje: 'Garage',
        'garasje uten felles': 'Garage without common area',
        gyldigFra: 'Valid from',
        gyldigTil: 'Valid to',
        hotell: 'Hotel',
        'kantine areal': 'Canteen area',
        kantine: 'Canteen',
        kontor: 'Office',
        kontrakt: 'Contract',
        kontraktAgreements: 'Agreements',
        kontraktAgreementsActive: 'Active contracts',
        kontraktAgreementsInfobox:
            'This page only shows active contracts. Full overview and downloads are available in ',
        kontraktFra: 'Contract from',
        kontraktNummer: 'Contract number',
        kontraktsdato: 'Contract date',
        kontraktsnummer: 'Contract number',
        kontraktTil: 'Contract to',
        kontraktGaranti: 'Obligation',
        kostPrPplassPrAr: 'Cost per parking space per year',
        lager: 'Warehouse',
        'lager uten fellesar': 'Warehouse without common area',
        m2: 'm²',
        unknownFileName: 'unknown filename',
        navn: 'Name',
        other: 'Other',
        parkering: 'Parking',
        pcs: 'pcs.',
        pris: 'Price',
        prisPerAar: 'Annual price',
        perAar: '/year',
        perM2: '/m²',
        perStk: '/pcs',
        pricePerUnit: 'Price per unit',
        reklameplass: 'Advertising space',
        relatedFiles: 'Related files',
        showFiles: 'Show files',
        restaurant: 'Restaurant',
        servering: 'Serving',
        teknisk: 'Technical',
        'teknisk uten felles': 'Technical without common area',
        til: 'To',
        fristOppsigelseLeietaker: 'Earliest possible date of termination',
        tomt: 'Plot',
        totaltAreal: 'Total area',
        'trening uten felles': 'Fitness without common area',
        verksted: 'Workshop',
        undervisning: 'Teaching',
        uteservering: 'Outdoor dining',
    },
    languageName: 'English',
    listUsers: {
        adminUserExplanation:
            'Admin user has full access to all data. Only KLP-users can have admin role.',
        notRegisteredInSuperOfficeWarning: {
            description:
                'In order for you to see or register users for this customer, the client must first be registered in SuperOffice',
            superOfficeButtonText: 'Open SuperOffice',
            title: 'This client is not registered in SuperOffice!',
        },
        superUserExplanation:
            'Superuser has access to contracts and invoices. NB! The customer can decide themselves to give such access to other users in their organisation.',
        superUserExplanationForUser:
            'Superuser has access to contracts and invoices. You can decide yourself to give such access to other users in your organisation.',
        title: 'Users',
        usersForCustomer: 'Users for {{customer}}',
    },
    message: {
        actions: {
            Deleted: 'Delete',
            Draft: 'Draft',
            Expired: 'Set expired',
            Published: 'Publish',
            WillPublish: 'Set publish',
            sendCopyToMe: 'Send me an email notification',
        },
        action: 'Action',
        addMessage: 'Add message',
        allMessages: 'All messages',
        backButton: 'Back to the message overview',
        download: 'Download message',
        category: {
            helperText: 'Select message category',
            name: 'Category',
        },
        categoryType: {
            Alert: 'Alert',
            Info: 'Info',
            Warning: 'Warning',
        },
        channel: {
            confirmEmail:
                'All recipients will receive email notification. Are you sure?',
            email: 'Send message by email',
            infoText: 'The email will be sent overnight.',
            yes: 'Yes, send',
            notificationSent: 'Notification sent to recipients {{timeSent}}',
            sendTonight: 'Send tonight',
            sendImmediately: 'Send immediately',
        },
        content: {
            helperText: 'Write your message',
            name: 'Message',
        },
        dialog: {
            Deleted: {
                action: 'Yes, delete',
                description: 'Do you want to delete message?',
                title: 'Delete message',
            },
            Draft: {
                action: 'Ja, set as draft',
                description: 'Do you want to change status to Draft?',
                title: 'Set as draft',
            },
            Expired: {
                action: 'Yes, set as expired',
                description: 'Do you want to change status to Expired?',
                title: 'Expired message',
            },
            Published: {
                action: 'Yes, publish',
                description: 'Do you want to publish this message?',
                title: 'Publish message',
            },
        },
        editMessage: 'Edit message',
        errorNoMessagesFound: {
            description: 'You have no messages at the moment.',
            title: 'You have no messages at the moment.',
        },
        expiresAt: {
            helperText: 'Select expiry date or leave blank',
            name: 'Expires at',
        },
        importantMessages: 'Important messages',
        isPinned: {
            helperText: 'You can pin the message to the top of newsfeed',
            name: 'Pin message',
        },
        messageDocuments: {
            helperText: 'You can select documents to be deleted',
            name: 'Documents',
        },
        messageImages: {
            helperText: 'You can select images to be deleted',
            name: 'Images',
        },
        messagePinned: 'This message is pinned to the top',
        messagesFor: 'Messages for {{kundeName}} ({{kundeNummer}})',
        messageStatus: 'Status',
        myMessages: 'My messages',
        publishAt: {
            helperText: 'Select publish date',
            name: 'Published at',
        },
        published: 'Published',
        readMore: 'Read more',
        seeAll: 'See all messages',
        status: {
            Deleted: 'Deleted',
            Draft: 'Draft',
            Expired: 'Expired',
            Published: 'Published',
            WillPublish: 'To be published',
        },
        title: {
            helperText: 'Enter the title',
            name: 'Title',
        },
        updated: 'Updated',
        // deprecated
        uploadedFiles: {
            helperText: 'You can select files to be deleted',
            name: 'Uploaded files',
        },
        // deprecated
        uploadFiles: {
            helperText:
                'Select new files to be uploaded when saving the message',
            name: 'New files',
        },
        noMessages: 'No messages found.',
    },
    region: {
        Danmark: 'Denmark',
        Europa: 'Europe',
        Konsolidert: 'Consolidated',
        Norge: 'Norway',
        Sverige: 'Sweden',
    },
    registerUser: {
        'A user with the provided email address already exists': {
            description:
                'A user with the provided email address already exists',
            title: 'Error occurred during registration of user.',
        },
        back: 'Back to users',
        disabledTooltip:
            'The button is disabled because it has not been selected whether a welcome message should be sent or not.',
        email: 'Email',
        firstName: 'Fist name',
        generalError: {
            description:
                'User registration failed. Please try again later or contact us and we will help you.',
            title: 'Error occurred during registration of user.',
        },
        lastName: 'Last name',
        registerNew: 'Register new user',
        registeringUser: 'Registering user...',
        successNotification: 'Successfully registered user.',
        title: 'Register user for {{customer}}',
        roles: {
            title: 'Roles',
            superUserCheckBox:
                'Should have access to contracts and invoices (Super user)',
        },
        other: {
            title: 'Other',
            velkomstmelding: 'Should a welcome message be sent?',
            yesButton: 'Yes',
            noButton: 'No',
        },
    },
    sak: {
        actions: {
            Active: 'Open',
            Closed: 'Close',
            Deleted: 'Delete',
            Merged: 'Merge',
            Postponed: 'Postpone',
        },
        addSak: 'New ticket',
        archivedTasksFor:
            'Archived tickets for {{kundeName}} ({{kundeNummer}})',
        backButton: 'Back to the ticket overview',
        confirmation: {
            title: 'Request registered',
            message:
                'Your request has been registered. We will respond to your case as soon as possible.',
        },
        buildingcategory: {
            helperText: 'Select property category',
            name: 'Property category',
        },
        category: {
            helperText: 'Select ticket category',
            name: 'Category',
        },
        created: 'Created at',
        dialog: {
            Active: {
                action: 'Yes, open',
                description: 'Do you want to open ticket?',
                title: 'Open ticket',
            },
            Closed: {
                action: 'Yes, close',
                description: 'Do you want to close ticket?',
                title: 'Close ticket',
            },
        },
        emne: 'Subject',
        email: 'Email',
        emailCopyRecipient: 'Copy to recipient:',
        errorDownload: {
            description: 'Something went wrong when fetching tickets.',
            title: 'Something went wrong when fetching tickets.',
        },
        errorNotFound: {
            description: 'No open tickets found.',
            title: 'No open tickets found.',
        },
        noTasks: 'No tasks found.',
        goBackToSaker: 'Go back to the tickets list',
        lukketDato: 'Closed',
        melding: 'Message',
        meldinger: {
            melding: {
                helperText: 'Write your reply',
                name: 'Reply',
            },
            noMoreMessages: 'No more tickets.',
            sendSvar: 'Send reply',
        },
        myArchivedTasks: 'My archived tickets',
        myTasks: 'My tickets',
        openArchive: 'Show archived tickets',
        openSakList: 'Show active tickets',
        opprettetAv: 'Created by',
        sakDocuments: {
            helperText: 'You can select documents to be deleted',
            name: 'Documents',
        },
        saksnummer: 'Ticket number',
        source: 'Source',
        sourceDalux: 'Dalux',
        sakImages: {
            helperText: 'You can select images to be deleted',
            name: 'Images',
        },
        sakLukketDato: 'Ticket closed {{lukketDato}}',
        sakskategori: {
            Administration: 'Administration',
            Sale: 'Sale',
            Support: 'Support',
            title: 'Category',
        },
        saksMelding: {
            title: '{{author}} wrote {{date}:',
        },
        sakStatus: {
            Aktiv: 'Active',
            Avsluttet: 'Closed',
            Sammenslått: 'Merged',
            Slettet: 'Deleted',
            Unknown: 'Unknown',
            Utsatt: 'Postponed',
            'Venter på 3dje part': 'Waiting for third party',
            'Venter på kunde': 'Waiting for customer',
        },
        sakStatusSummary: {
            EjPaborjad: 'Not started',
            Utskriven: 'Printed',
            Utringd: 'Called',
            Kvitterad: 'Acknowledged',
            Aktiv: 'Active',
            Aktiv_1: 'Active',
            Avsluttet: 'Closed',
            Avsluttet_1: 'Closed',
            Sammenslått: 'Merged',
            Sammenslått_1: 'Merged',
            Slettet: 'Deleted',
            Slettet_1: 'Deleted',
            Unknown: 'Unknown',
            Unknown_1: 'Unknown',
            Utsatt: 'Postponed',
            Utsatt_1: 'Postponed',
            'Venter på 3dje part': 'Waiting for third party',
            'Venter på 3dje part_1': 'Waiting for third party',
            'Venter på kunde': 'Waiting for customer',
            'Venter på kunde_1': 'Waiting for customer',
        },
        savingError: 'Error during saving the ticket',
        savingSuccess: 'Saved',
        searchSak: 'Search for tickets',
        showAll: 'Show all messages',
        status: 'Status',
        subcategory: {
            helperText: 'Select ticket sub-category',
            name: 'Sub-category',
        },

        supportcategory: {
            helperText: 'Select support category',
            name: 'Support category',
        },
        summarytitle: 'Recent tickets',
        tasksFor: 'Tickets for {{kundeName}} ({{kundeNummer}})',
        vedlegg: {
            title: 'Attachments',
        },
    },
    superOffice: {
        issue: {
            new: 'New ticket',
            status: {
                temporary: 'temporary',
                todo: 'todo',
            },
            title: 'Recent issues',
        },
        langCode: 'en',
        mytasks: 'My tickets',
        noaccess: "You don't have access to SuperOffice",
        opening: 'Opening SuperOffice...',
    },
    supportForm: {
        attachments: {
            attachments: 'Last opp vedlegg',
            attachmentsHelperText: 'Velg filene som skal lastes opp',
            title: 'Vedlegg',
        },
        company: {
            companyName: 'Juridisk navn på selskap',
            companyNameHelperText: 'Skriv inn juridisk navn på selskapet',
            orgNumber: 'Organisasjonsnummer',
            orgNumberHelperText: 'Skriv inn organisasjonsnummer',
        },
        contact: 'Kontakt',
        description:
            'Forklaring hvorfor hjelper vi våre leietakere. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur massa libero, eleifend eu erat sed, consequat malesuada lacus. Suspendisse vitae neque ut lacus ultricies blandit. Pellentesque elementum, nulla quis accumsan pellentesque, enim metus sagittis justo, eget pellentesque sapien tortor at odio. Nam nulla orci, pharetra vitae dignissim in, sagittis sit amet neque. Sed sed massa eget arcu scelerisque dapibus. Suspendisse bibendum erat quis lorem maximus dignissim. Vivamus risus tortor, interdum vehicula molestie ut, tempor et felis. Vestibulum aliquam interdum lectus, et interdum lorem gravida eget. Vivamus vulputate placerat nulla, ut consectetur ante rhoncus quis. Fusce sem enim, efficitur vitae ante in, sagittis vulputate dolor. Vivamus nec massa sem. Proin in tincidunt tellus. Nulla eget leo quis nisi cursus congue.',
        economy: 'Statens kompensasjonsordning',
        email: {
            email: 'Email',
            emailHelperText: 'Please write your email',
        },
        governmentSupport: {
            amount: 'Sum',
            amountHelperText: 'Skriv inn summen her',
            caseNumber: 'Saksnummer',
            caseNumberHelperText: 'Skriv inn saksnummeret',
            governmentSupport: 'Har du fått støtte fra staten?',
            governmentSupportExplanation: 'Hvis nei, hvorfor ikke?',
            governmentSupportExplanationHelperText:
                'Fortell gjerne hvorfor du ikke har fått støtten',
            governmentSupportHelperText:
                'Velg om du har fått støtte fra staten',
            month: 'Måned',
        },
        invoice2020Q3: {
            invoiceNumber: 'Fakturanummer Q3 2020',
            invoiceNumberHelperText: 'Skriv inn fakturanummeret for Q3 2020',
        },
        kundeNummer: {
            clientNumber: 'Kundenummer hos KLP',
            clientNumberHelperText: 'Skriv inn kundenummeret hos KLP',
        },
        leietakerinformasjon: 'Leietakerinformasjon',
        other: {
            klpSupportReasonHelperText: 'Skriv din forklaring her',
            klpSupportReasonTitle:
                'Beskriv hvorfor du trenger støtte etter at statens ordning opphører',
            klpSupportReasonTitleShort: 'Begrunnelse',
            title: 'Øvrig',
        },
        personApplying: {
            personName: 'Navn på søker',
            personNameHelperText: 'Skriv inn ditt navn',
        },
        phoneNumber: {
            phoneNumber: 'Telefonnummer',
            phoneNumberHelperText: 'Skriv inn telefonnummer',
        },
        registerForm: 'Registrer søknad',
        revenue: {
            amount: 'Sum',
            amountHelperText: 'Skriv inn summen her',
            month: 'Måned',
            revenue2019: '2019',
            revenue2020: '2020',
            title: 'Omsetningstall',
        },
        shoppingCenter: {
            shoppingCenterHelperText: 'Velg senteret',
            shoppingCenterName: 'Sentertilknytning',
        },
        store: {
            storeName: 'Butikknavn',
            storeNameHelperText: 'Skriv inn butikknavnet',
        },
        support: 'Støtteordning',
        title: 'Søknad om støtte',
    },
    tables: {
        labelRowsPerPage: 'Rows per page:',
    },
    user: {
        myAccount: 'My account',
    },
    userSearch: {
        activeUsers: 'Active users',
        addCustomer: 'Add',
        addCustomerError: 'Error occurred while adding customer.',
        addCustomerSuccess: 'Successfully added customer {{customer}}',
        addCustomerTitle: 'Add customer',
        grantAdminError: 'Could not grant admin privileges to {{email}}.',
        grantAdminQuestion: 'Grant admin privileges to {{email}}?',
        grantAdminSuccess: 'Granted admin privileges to {{email}}.',
        grantSuperUserError:
            'Could not grant super user privileges to {{email}}?',
        grantSuperUserQuestion: 'Grant super user privileges to {{email}}?',
        grantSuperUserSuccess: 'Granted super user privileges to {{email}}?',
        grantSuperUserTooltip:
            'Grants or removes access to contracts and invoices',
        inActiveUsers: 'Inactive users',
        invitationNotSent: 'Not sent',
        invitationSent: 'Invitation sent',
        invite: 'Invite',
        inviteActivateUser: 'Invite/activate user',
        inviteUserError: 'Error while sending invitation to {{email}}.',
        inviteUserQuestion: 'Do you want to send an invitation to {{email}}?',
        inviteUserSuccess: 'Successfully sent invitation to {{email}}.',
        refreshingList: 'Refreshing list...',
        removeCustomerError: 'Error occurred while removing customer.',
        removeCustomerQuestion:
            'Do you want to revoke access to customer {{customer}} for {{email}}?',
        removeCustomerSuccess: 'Successfully removed user {{user}}',
        removeUserSuccess: 'Sucessfully removed access for {{user}}',
        removeUserError: 'Could not delete user',
        removeUserTitle: 'Delete user',
        removeUserQuestion: 'Do you want to delete user {{email}}?',
        remove: 'Delete',
        removeCustomerTitle: 'Revoke access to customer',
        revokeAdminError: 'Could not revoke admin privileges for {{email}}.',
        revokeAdminQuestion: 'Revoke admin privileges for {{email}}?',
        revokeAdminSuccess: 'Revoked admin privileges for {{email}}.',
        revokeSuperUserError:
            'Could not revoke super user privileges for {{email}}?',
        revokeSuperUserQuestion: 'Revoke super user privileges to {{email}}?',
        revokeSuperUserSuccess: 'Revoked super user privileges for {{email}}?',
        searchPlaceholder: 'Search',
        searchResults: 'Found {{count}} users',
        searchResults_1: 'Found {{count}} user',
        searchTitle: 'Search for users',
        send: 'Send',
        sendNewWelcomeMessage: 'Send new welcome message',
        sendWelcomeMessageError:
            'Error while sending welcome message to {{email}}.',
        sendWelcomeMessageQuestion:
            'Do you want to send welcome message to {{email}}?',
        sendWelcomeMessageSuccess:
            'Successfully sent welcome message to {{email}}}.',
        userCustomers: 'Customers',
        userEmail: 'Email',
        userFirstName: 'First name',
        userIsAdmin: 'Admin user',
        userIsSuperUser: 'Super user',
        userIsOrdinaryUser: 'Ordinary user',
        userLastName: 'Last name',
        welcomeMessageSent: 'Welcome message sent',
        grantSuperUser: 'Grant superuser access',
        grantAdminUser: 'Grant admin user access',
        revokeSuperUser: 'Remove superuser access',
        revokeAdminUser: 'Remove admin user access',
        role: 'Role',
        action: 'Action',
    },
    validator: {
        email: 'Valid email is required',
        required: 'The field is required',
    },
};
